module.exports = __webpack_public_path__ + "img/download_w.81e347cf.svg";